import MuiTableRow from "@mui/material/TableRow";
import { useTableConstructor } from "layout/TableConstructor/context/tableConstructorContext";
import {
  GetRowBackgroundColor,
  IdentifiableWithCalculatedParams,
  OnRowClick,
  TableSelectedProps,
} from "layout/TableConstructor/types";
import TableCell from "./TabelCell";
import RowCheckbox from "./TableRowCheckbox";

interface CollapsingRowProps<
  T extends IdentifiableWithCalculatedParams,
  CollapsingRowName extends keyof T | undefined = undefined,
> {
  row: T;
  collapsingRowName: CollapsingRowName | undefined;
  onRowClick: OnRowClick<T, CollapsingRowName> | undefined;
  open: boolean;
  getRowBackgroundColor?: GetRowBackgroundColor<T>;
  selectedProps?: TableSelectedProps<T["id"]>;
}

const CollapsingRow = <
  T extends IdentifiableWithCalculatedParams,
  CollapsingRowName extends keyof T | undefined = undefined,
>({
  collapsingRowName,
  row,
  open,
  onRowClick,
  getRowBackgroundColor,
  selectedProps,
}: CollapsingRowProps<T, CollapsingRowName>) => {
  const { visibleColumnConfig } = useTableConstructor();

  if (
    row.isCollapsingRow &&
    collapsingRowName &&
    Array.isArray(row[collapsingRowName]) &&
    row[collapsingRowName]?.length &&
    open
  ) {
    const collapsingRow = row[collapsingRowName];
    return collapsingRow.map((collapsedRow) => (
      <MuiTableRow
        onClick={() => onRowClick?.(row, collapsedRow)}
        sx={{
          backgroundColor: getRowBackgroundColor?.(collapsedRow) || undefined,
          cursor: onRowClick ? "pointer" : "default",
        }}
        key={`collapsed-row-${collapsedRow.id}`}>
        <TableCell
          onClick={(e) => selectedProps && e.stopPropagation()}
          sx={selectedProps && { cursor: "default" }}>
          {selectedProps && (
            <RowCheckbox
              selectedProps={selectedProps}
              row={collapsedRow}
            />
          )}
        </TableCell>
        {visibleColumnConfig.map((col) => (
          <TableCell key={`cell-row-${collapsedRow.id}-col-${col.name}`}>
            {"renderCollapse" in col && typeof col.renderCollapse === "function"
              ? // @ts-expect-error порешать потом с типом TODO
                col.renderCollapse(collapsedRow)
              : col.render(row)}
          </TableCell>
        ))}
      </MuiTableRow>
    ));
  }

  return null;
};

export default CollapsingRow;
